import validator from "validator"
import { getValue } from "./commonHelper";

const validationMap: any = {
  required: ({ value }: any) => { 
    if(typeof value == "number") {
      let result = value == 0 ? true : false;
      return result;
    } else {
      return validator.isEmpty(value);
    }
  },
  comboRequired: ({ value }: any) => {
    if (validator.isEmpty(value) || (value && value == '-1' || value == -1)) {
      return true;
    }
  },
  email: ({ value }: any) => !validator.isEmail(value),
  password: ({ value }: any) => !validator.isStrongPassword(value, {
    minLength: 8,
    minLowercase: 1,
    minUppercase: 1,
    minNumbers: 1,
    minSymbols: 1
  }),
  number: ({ value }: any) => {
    if(!value) return false;
    return !validator.isNumeric(value.toString());
  },
  alphaNumeric: ({ value }: any) => validator.isAlphanumeric(value),
  equalValidator: ({ value, args, model }: any) => value !== model[args.compareTo],
  lengthValidator: ({ value, args, model }: any) => {
    if(!value) return false;
    return (value.length != args.length);
  },
  mobile: ({ value }: any) => {
    const numericPattern = "^[0-9]{10}$";
    const result = !validator.matches(value, numericPattern);
    return result;
  }
}

export const FormValidator = {
  /**
   * This method used to validate all the input controls
   * @param validationModelMap
   * @param formModel
   */
  bulkValidate(validationModelMap: any, formModel: any) {
    let result: any = {}
    let hasError = false;
    for (const key in validationModelMap) {
      let value = getValue(formModel, key);
      const item = {
        name: key,
        value: value,
        validations: validationModelMap[key],
        model: formModel
      }
      const validationResult = FormValidator.validate(item)
      result[key] = validationResult
      if (!hasError) // { required: false, email: true} - means the input is not valid email, hasError is true in that case
        hasError = Object.keys(validationResult).some(val => validationResult[val])
    }
    return { isValid: !hasError, errors: result }
  },

  /**
   *
   * @param options
   */
  validate(options: any) {
    const value = options.value || ""
    const validations = options.validations
    let result: any = {}
    if (validations && validations.length > 0) {
      // Result of each validation must be true if the input is invalid and false if valid.
      validations.forEach((validation: any) => {
        const key = (typeof validation === "object") ? validation.key : validation
        if (!validationMap[key]) throw new Error("Unrecognized validator")
        result[key] = validationMap[key]({ value, args: validation.args, model: options.model })
      })
    }
    return result
  }
}
